import React from "react";
import "./MobileVersion.css";
import { useApp } from "../../AppContext/AppContext";

const MobileVersion = () => {
  const { currentColor } = useApp();

  return (
    <section className="mobile-version">
      <h2 className="mobile-version__title">
        Mobile <span style={{ color: currentColor }}>Version</span>
      </h2>

      <p className="mobile-version__subtitle">
        Effortless Video Downloads at Your Fingertips
      </p>

      <div>
    
          <img src="/assets/mobileVersion.svg" alt="Download our mobile app" />
        
        <div className="mobile-version__button-container">
        <a 
        href="https://play.google.com/store/apps/details?id=com.hdvideodownloader.downloaderapp"
        className="video-downloader__store-link"
        aria-label="Download on App Store"
        target="_blank"
        rel="noopener noreferrer"
        >
          <button className="mobile-version__button">
            Download
          </button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default MobileVersion;
